(function () {
    var loadHtml = [];
    // prettier-ignore
    loadHtml[1] ='<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>크리에이터 ‘최단 기간 백만 구독자를 향해’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#브이로거, #영상편집, #CG</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-01_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-02_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-03_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont04">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-04_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-04_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont05">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-05_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-05_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont06">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-06_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-01-06_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
                '<dl>'+
                    '<dt>크리에이터 ‘최단 기간 백만 구독자를 향해’</dt>'+
                    '<dd><em>#브이로거, #영상편집, #CG</em></dd>'+
                    '<dt>오늘도 촬영 중!</dt>'+
                    '<dd>1인 크리에이터인 나에게 가장 필요한건?</dd>'+
                    '<dd><em>Filming, New Season</em></dd>'+
                    '<dt>편집부터 렌더링까지 가볍게 빠르게!</dt>'+
                    '<dd>1인 크리에이터에게 필요한 제1 덕목은 SPEED</dd>'+
                    '<dd>'+
                        '4K 영상도 현장에서 바로 편집할 수 있는 성능은 필수죠.'+
                        '강력한 외장그래픽이 탑재되어 성능에 대한 갈증은 없어졌어요!'+
                        '높은 해상도에 생생한 컬러, 그리고  넓은 워크스페이스까지!'+
                        '이제 현장에서도 모든 작업을 마무리 할 수 있어요.'+
                    '</dd>'+
                    '<dt>Nvidia RTXTM 2050</dt>'+
                    '<dd>그램 최초 외장그래픽 탑재로 이제 무거운 작업도 가볍고 빠르게!</dd>'+
                    '<dt>16:10 화면비</dt>'+
                    '<dd>세로비율이 더 넓어진 화면비로 작업 효율도 좋아요!</dd>'+
                    '<dt>WQXGA(2560x1600)</dt>'+
                    '<dd>두배 더 선명하고 생생한 해상도로 결과물의 퀄리티도 좋아요!</dd>'+
                    '<dt>* 인텔 EVO CPU / 4K 영상편집 / RTX 2050</dt>'+
                    '<dt>인텔 EVO CPU</dt>'+
                    '<dd>* 인텔 Evo는 아래 gram 모델에 한해 탑재됩니다.</dd>'+
                    '<dd>모델명 Z90Q (i5 이상, OS 탑재모델, 내장 그래픽 모델)</dd>'+
                    '<dd>모델명 T90Q (i5 이상, OS 탑재모델)</dd>'+
                    '<dt>4K 영상편집</dt>'+
                    '<dd>* 촬영 영상이 비트레이트 100M 미만인 경우에 한합니다.</dd>'+
                    '<dd>* 화면 확장은 연결된 PC에서 별도 설정 시 가능합니다.</dd>'+
                    '<dd>* 그램+view는 별매입니다.</dd>'+
                    '<dd>* 이해를 돕기 위해 연출된 장면으로 실제와 다를 수 있습니다.</dd>'+
                    '<dt>RTX 2050</dt>'+
                    '<dd>* NVIDIA GeForce RTX™ 2050은 16Z90Q 및 17Z90Q 일부 모델에 한해 탑재됩니다.</dd>'+
                    '<dd>* 그램+view는 별매입니다.</dd>'+
                    '<dd>* 고사양 작업 시, LG Smart Assistant에서 ‘고성능 모드‘ 설정을 권장합니다.</dd>'+
                    '<dd>* 이해를 돕기 위해 연출된 장면으로 실제와 다를 수 있습니다.</dd>'+
                    '<dt>뷰다익선! 그램+view</dt>'+
                    '<dd>'+
                        '화면은 넓을 수록 많을 수록 좋죠.'+
                        '가볍게 가져갈 수 있는 그램+view는 '+
                        '제게 존재 자체가 축복이죠.'+
                    '</dd>'+
                    '<dt><em>* 그램+view</em></dt>'+
                    '<dd>'+
                        '<ul>'+
                            '<li>* 화면 확장은 연결된 PC에서 별도 설정 시 가능합니다.(LG Glance by Mirametrix®)</li>'+
                            '<li>* 그램+view와 연결된 장치의 배터리가 부족할 경우 연결이 끊어질 수 있습니다.</li>'+
                            '<li>* 그램+view에는 배터리가 내장되어 있지 않습니다.</li>'+
                            '<li>* 연결되는 장치가 7.5W(5V/1.5A) 이상의 DisplayPort Alternate Mode 및 전원 출력(USB PD)을 지원해야 합니다.</li>'+
                            '<li>* 그램+view는 별매입니다.</li>'+
                            '<li>* 이해를 돕기 위해 연출된 장면으로 실제와 다를 수 있습니다.</li>'+
                        '</ul>'+
                    '</dd>'+
                    '<dd>'+
                        '두 개의 대화면을 하나처럼 자유롭게 활용하게 해줄'+
                        '그램+view는 가볍게 휴대할 수 있고 '+
                        '그램과도 딱 붙는 찰떡 궁합을 자랑합니다.'+
                    '</dd>'+
                    '<dd>'+
                        'C type usb 포트만 연결하면 '+
                        '어디에서든 자유롭게'+
                        '듀얼플레이가 가능하죠! '+
                    '</dd>'+
                '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[2] = '<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>게이머 ‘최고의 보급은 역시 그램’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#즐겜러, #스펙광</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-01_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-02_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-03_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-02-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
                '<dl>'+
                    '<dt>게이머 ‘최고의 보급은 역시 그램’</dt>'+
                    '<dd>#즐겜러, #스펙광</dd>'+
                    '<dt>이겼닭! 오늘 저녁은 치킨이닭! 무거운 게임도 가볍게 해줄 RTX 2050 탑재!</dt>'+
                    '<dd>찰나의 타이밍을 놓치지 않는 순발력은 성능이 받쳐 줘야 가능하죠. 이제 그램은 가볍기만 하지 않아요! 강력하기까지 하죠! 이젠 그램만 있으면 꼭 집이 아니더라도 어디서나 로그온!</dd>'+
                    '<dd>GeForce RTX™ 2050은 현실적인 그래픽을 구현해 주는 레이트레이싱과 빠른 게임 속도를 가능하게 해주는 NVIDIA ® DRSS를 지원해요.</dd>'+
                    '<dd><em>* RTX 2050</em></dd>'+
                    '<dt>타건감이 바로 타격감! 타격감의 비밀은?</dt>'+
                    '<dd>'+
                        '키보드에서 느껴지는 타격감도 게임 몰입을 위해선 '+
                        '빠질 수 없는 조건이죠!'+
                        '그램에서 느껴지는 쫀쫀한 '+
                        '타격감은 다른 울트라북에서는 느끼기 힘들죠.'+
                        '그 이유는 바로 깊은 키스트로크!<em>1.65mm</em>'+
                    '</dd>'+
                '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[3] =
    '<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>아티스트 ‘크리에이티브도 그램처럼!’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#프로듀서, #디자이너</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-01_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-02_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-03_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont04">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-04_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-04_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont05">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-05_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-03-05_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
            '<dl>'+
            '<dt>아티스트 ‘크리에이티브도 그램처럼!’</dt>'+
            '<dd><em>#프로듀서, #디자이너</em></dd>'+
            '<dt><em>프로듀서</em> 악상이 떠오르면 온라인으로 즉석 프로듀싱! 나만의 그램 스튜디오! 프로듀싱도 자유롭게 가볍게!</dt>'+
            '<dt>그램과 그램+view만 있으면 모이지 않아도 작곡이 가능해요.</dt>'+
            '<dd>두개의 대화면을 하나처럼 자유롭게 활용할 수 있는 그램+view는 어디에서든 자유롭게 화면을 확장할 수 있게 해주죠. 떨어져 있어도 함께 하는 느낌! 바로 이 느낌!</dd>'+
            '<dd><em>* 그램+view</em></dd>'+
            '<dt><em>디자이너</em> 저는 상상력에 제약을 두지 않아요 플렉서블한 아이디어, 360도 회전 힌지</dt>'+
            '<dt>다양한 모드로 자유롭게</dt>'+
            '<dd>360도 터치디스플레이로 어떤 상황에서도 자유롭게!</dd>'+
            '<dd>랩탑모드</dd>'+
            '<dd>태블릿모드</dd>'+
            '<dd>텐트모드</dd>'+
            '<dd>스탠드모드</dd>'+
            '<dd>평면모드</dd>'+
            '<dt>내 드로잉 스타일 그대로 와콤 스타일러스 펜</dt>'+
            '<dd>섬세한 필압, 편안한 그립감 이질감 없는 핸드 드로잉에 이만한 펜도 없죠!</dd>'+
            '<dd><em>섬세한 4,096 필압 와콤 스타일러스 펜</em></dd>'+
            '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[4] =
    '<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>학생 ‘24시간이 모자란 열정 콜렉터’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#열공모드, #대학생</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-01_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-02_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-03_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont04">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-04_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-04-04_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
            '<dl>'+
            '<dt>학생 ‘24시간이 모자란 열정 콜렉터’</dt>'+
            '<dd><em>#열공모드, #대학생</em></dd>'+
            '<dt><em>999g의 의미</em> 짐이 되지 않는 파트너</dt>'+
            '<dd>왕복2시간 등하교시간+ 조별과제 + 동아리 활동 온종일 함께 하려면 서로에게 짐이 되지 않아야죠.</dd>'+
            '<dd><em>1kg가 넘지 않는 초경량 노트북은 역시 그램이죠!</em></dd>'+
            '<dt>필기는 내게 맡겨 손 글씨가 예쁜 친구의 단짝 노트북은 그램360</dt>'+
            '<dd>'+
            '우리 조의 강점은 효율과 분업이죠!'+
            '그램 360을 사용하는 친구가'+
            '와콤 스타일러스 '+
            '펜으로 필기 한 내용을 모두에게 공유해요.'+
            '</dd>'+
            '<dd>섬세한 4,096 필압 내 글씨체 그대로 와콤 스타일러스 펜!</dd>'+
            '<dt>온종일 함께 해줘서 고마워</dt>'+
            '<dd>'+
            '충전 어댑터까지 챙겨야 한다면 '+
            '초경량이 무슨 의미?'+
            '하루 종일 지치지 않는 제 체력은 '+
            '그램의 배터리와 닮았죠!'+
            '</dd>'+
            '<dd>72Wh 대용량 배터리는 외출 시 충전기를 챙기지 않아도 온 종일 쌩쌩해요.</dd>'+
            '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[5] ='<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>회사원 ‘언제나 명확한 정팀장님의 선택’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#N잡러 #워라밸 #갓생살기</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-01_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-02_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-03_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont04">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-04_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-05-04_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
            '<dl>'+
            '<dt>회사원 ‘언제나 명확한 정팀장님의 선택’</dt>'+
            '<dd><em>#N잡러 #워라밸 #갓생살기</em></dd>'+
            '<dt>정팀장님은 엑셀의 신이라며?</dt>'+
            '<dd>회사업무에 엑셀을 다루는 능력은 필수죠. 여기에 텐키가 없다는 건? 말이 안되죠.</dd>'+
            '<dd>슬림한 폼펙터가 품은 텐키 그램만의 장점! 이거 없으면 프로 일잘러의 노트북이라 할 수 없겠죠.</dd>'+
            '<dd>텐키가 있는 노트북과 없는 노트북! 어떤게 일잘러의 노트북일까요? 그램16이 바로 일잘러의 노트북!</dd>'+
            '<dt>팀장님은 동에 번쩍 서에 번쩍, 팀장님은 지치지도 않으신다고요?</dt>'+
            '<dd>연속되는 회의와 미팅, 거래처 방문까지. 업무의 무게를 견뎌줄 가벼운 그램과 함께 하면 되겠죠!</dd>'+
            '<dd>업무는 무거워도 노트북은 가벼워야죠! 초경량을 원한다면 그램14가 답이죠!</dd>'+
            '<dt>업무도 회의도 빠르고 유연하게! 피드백을 구하러 오는 부사수는 언제나 환영</dt>'+
            '<dd>장소에 구애 받지 않고 바로 회의 자리가 될 수 있도록 세팅할 수 있는건 그램+view 덕분입니다.</dd>'+
            '<dd>두 개의 대화면을 하나처럼 자유롭게 활용하게 해줄 그램+view로 업무를 할 때도 회의를 할 때도 상황에 따라 가볍고 유연하게 활용할 수 있어요!</dd>'+
            '<dd><em>* 그램+view</em></dd>'+
            '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[6] =
    '<!-- gram 추천(type6) -->'+
    '<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>OTT부자 ‘시리즈는 몰아봐야 제 맛’</h3>'+
            '<div class="flag-wrap">'+
            '<span class="flag">#영화광, #드라마홀릭</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-06-01_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-06-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-06-02_pc.jpg" alt="" class="pc-only">'+
            '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-06-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
            '<dl>'+
            '<dt>OTT부자 ‘시리즈는 몰아봐야 제 맛’</dt>'+
            '<dd>#영화광, #드라마홀릭</dd>'+
            '<dt>이번 주말은 완결을 기다려온 시리즈 한 번에 몰아보기, 대화면 고해상도 그리고 몰입감</dt>'+
            '<dd>침대나 소파에서 10시간은 버틸 최대한 편안한 자리 만들기. 그러기 위해서 필요한 건? 가볍게 옮길 수 있는 크고 선명한 화면이겠지.</dd>'+
            '<dt>WQXGA 초고해상도와 17인치 대화면, 그리고 DCI_P3 99%의 높은 색재현율</dt>'+
            '<dd>어떤 컨텐츠를 감상하든 선명하고 높은 몰입력을 느낄수 있죠</dd>'+
            '<dd>WQXGA 초고해상도</dd>'+
            '<dd>17인치 대화면</dd>'+
            '<dd>99% 색재현율</dd>'+
            '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    loadHtml[7] =
    '<!-- gram 추천(type7) -->'+
    '<div >'+
        '<h2 class="blind">그램 추천</h2>'+
        '<div class="tit-wrap">'+
            '<h3 class="tit"><span class="blind">제목</span>배낭여행자 ‘백팩킹은 역시 그램 줄이기가 관건!’</h3>'+
            '<div class="flag-wrap">'+
                '<span class="flag">#배낭여행, #여행블로거, #떠날땐가볍게</span>'+
            '</div>'+
        '</div>'+
        '<div class="img">'+
            '<div class="story-cont01">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-01_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-01_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont02">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-02_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-02_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="story-cont03">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-03_pc.jpg" alt="" class="pc-only">'+
                '<img src="/lg5-common/images/GRC/recom/img-recommend-detail-07-03_mo.jpg" alt="" class="mo-only">'+
            '</div>'+
            '<div class="blind">'+
                '<dl>'+
                    '<dt>배낭여행자 ‘백팩킹은 역시 그램 줄이기가 관건!’</dt>'+
                    '<dd><em>#배낭여행, #여행블로거, #떠날땐가볍게</em></dd>'+
                    '<dt>오늘은 숲 속에서 나홀로 1박, 발길 닿는 대로 어디든 떠나는 나는 배낭여행 블로거</dt>'+
                    '<dd>백팩킹은 짐을 최대한 가볍게 하는 노하우가 필요하죠. 목적지에서 느끼는 감성이 사라지기전 현장에서 포스팅을 하는게 제 블로그 컨셉입니다.</dd>'+
                    '<dd><em>999g 짐이 되지 않는 무게, 바로 그램 뿐이죠</em></dd>'+
                    '<dt>어디서든 편집, 언제든지 업로드</dt>'+
                    '<dd>넉넉한 저장공간 덕에 걸으며 찍은 사진과 영상들을 모두 백업할 수 있어요. 16:10 화면비 모니터로 간단하게 보정과 편집도 무리 없고요</dd>'+
                    '<dd>DCI_P3기준 99%의 높은 색재현율을 보여주는 프로디스플레이는 야외에서도 선명한 화질을 보여줘요</dd>'+
                '</dl>'+
            '</div>'+
        '</div>'+
    '</div>';

    //타이틀
    var MKTF30022_tmpl_title = '<h2 class="blind">그램 추천</h2>'+
    '<div class="tit-wrap">'+
        '<h3 class="tit"><span class="blind">제목</span>{{ curationItem.curationName +" ‘"+ curationItem.curationTitle.replace(/(<BR)(.)(>)/g," ")+"’"}}</h3>'+
        '<div class="flag-wrap">'+
            '<span class="flag">{{curationItem.curationTag.replace(/ /g,"").replace(/#/g,", #").replace(", #","#")}}</span>'+
        '</div>'+
    '</div>';

    // prettier-ignore
    //제품추천 (최대 4개)
    var MKTF30022_tmpl_product = 
    '{{#each item,index in productInfoList}}'+
        '{{#if index < 4}}'+
            '<li class="lists">'+
                '<div class="list-inner">'+
                    '<a href="{{item.modelUrlPath}}" data-contents="{{item.modelDisplayName}}/{{item.modelName}}">'+
                        '<span class="thumb"><img src="{{item.mediumImageAddr}}" alt="{{item.modelDisplayName}}"></span>'+
                        '<div class="prod-info">'+
                            '<div class="prod-name"><span class="main-title"><span class="main">{{#raw item.modelDisplayNamePlusSpec}}</span></span></div>'+
                            '<div class="sku">{{item.modelName}}</div>'+
                            '<span class="price">{{item.mallCount > 1 && "최저"}}{{vcui.number.addComma(item.salePrice)}}원</span>'+
                            '{{#if item.mallCount == 1}}'+
                                '{{#if item.mallName == "LGE.COM"}}'+
                                '<span class="sales-place">LGE.COM / LG 베스트샵</span>'+
                                '{{#else}}' +
                                '<span class="sales-place">{{item.mallName}}</span>'+
                                '{{/if}}'+
                            '{{#else}}' +
                            '<span class="sales-place">{{item.mallCount}}개 판매처 보기</span>'+
                            '{{/if}}'+
                        '</div>'+
                    '</a>'+
                '</div>'+
            '</li>'+
        '{{/if}}'+
    '{{/each}}';

    // prettier-ignore
    //업셀링 제품추천 TAB
    var MKTF30022_tmpl_product_up_tab = 
    '{{#each item in upsellingList}}'+
        '<li><a href="#" data-id="{{item.upsellingId}}">{{item.upsellingName}}</a></li>'+
    '{{/each}}';

    // prettier-ignore
    //업셀링 제품추천 리스트
    var MKTF30022_tmpl_product_up_list = 
    '{{#each item in productInfoList}}'+
        '<li class="lists">'+
            '<div class="list-inner">'+
                '<a href="{{item.modelUrlPath}}">'+
                    '<span class="thumb"><img src="{{item.mediumImageAddr}}" alt="{{item.modelDisplayName}}"></span>'+
                    '<div class="prod-info">'+
                        '<span class="main-title"><span class="main">{{#raw item.modelDisplayNamePlusSpec}}</span></span>'+
                        '<div class="sku">{{item.modelName}}</div>'+
                        '<div class="sku">{{item.upSpecText && item.upSpecText.replace(/&reg;/g,"")}}</div>'+
                    '</div>'+
                '</a>'+
            '</div>'+
        '</li>'+
    '{{/each}}';

    var MKTF30022 = {
        publUrl: {
            jsonLifeStyleResult: "/lg5-common/data-ajax/gram/lifeResult.json",
            jsonLifeStyleUpResult: "/lg5-common/data-ajax/gram/lifeUpResult.json",
            lifeReUrl: "/html/GRC/MKTF30021.html",
            lifeFindUrl: "#find",
            curationUrl: "/html/GRC/MKTF30021-type{{id}}.html",
        },
        url: {
            jsonLifeStyleResult: "/mkt/api/gram/retrieveGramCurationResult.lgajax",
            jsonLifeStyleUpResult: "/mkt/api/gram/retrieveGramCurationUpsellingResult.lgajax",
            lifeReUrl: "/gram/persona",
            lifeFindUrl: "/gram/find",
            curationUrl: "/html/GRC/MKTF30021-type{{id}}.html",
        },
        isPubl: true,
        filterParam: "",
        dataUpsellingList: [],
        init: function () {
            var self = this;
            self.$el = $(".MKTF30022");
            self.$tbd = $(".recommend-detail-wrap");
            self.curationId = self.getAllUrlParams().curationId || 1;

            //퍼블에서 적용
            self.$tbd.css("height", "auto");
            //box-list type-04
            self.$addTmplProduct = self.$el.find(".recom-product .box-list-inner");
            self.$addTmplProductUpTabs = self.$el.find(".gray-full-box .tabs");
            self.$bnrH = self.$el.find(".gray-full-box .desc-box .tit");
            self.$bnrP = self.$el.find(".gray-full-box .desc-box .txt");
            self.$total = self.$el.find(".gray-full-box #totalCount em");
            self.$uiTab = $(".gray-full-box .ui_tab");

            self.floatingBtn = $(".life-style-btn-wrap .btn");
            self.requestData(self.getUrl().jsonLifeStyleResult, { curationId: self.curationId }, function (result) {
                var data = result.data[0];
                var lifeReUrl = self.getUrl().lifeReUrl;
                var bannertUrl = self.getUrl().lifeFindUrl;
                self.$el.find(".btn.border.size-m").eq(0).attr("data-href", lifeReUrl);
                $(".banner.cont-wrap a").attr("href", bannertUrl);
                var titleLists = vcui.template(MKTF30022_tmpl_title, data);
                self.$tbd.css('visibility','hidden');   
                var curationDescription = result.data[0].curationItem.curationDescription;
                if(curationDescription.indexOf('class="mo-only"')>-1){
                    self.$tbd.html(titleLists + curationDescription);
                }else{
                    curationDescription = curationDescription.replace(/( src\=\")(.*?)(\")/gs,'');
                    self.$tbd.html(titleLists + curationDescription.replace('recommend-detail-wrap','recommend-detail-inner'));
                }
                //sticky
                if($('.ui_sticky_recomm').vcSticky){
                    $('.ui_sticky_recomm').vcSticky({stickyContainer:'.wrap.gram-only'})
                    $('.ui_sticky_recomm').addClass('ui_sticky')
                }else{
                    vcui.require([
                        'ui/sticky',
                    ], function () {
                        $('.ui_sticky_recomm').vcSticky({stickyContainer:'.wrap.gram-only'})
                        $('.ui_sticky_recomm').addClass('ui_sticky')
                    }); 
                }
                //제품추천 리스트
                if (!data.productInfoList || data.productInfoListCount == 0 || data.productInfoList.length == 0) {
                    self.$addTmplProduct.hide();
                    self.$el.find(".recom-product .btn-area").hide();
                    self.$el.find(".no-data").show();
                } else {
                    //제품추천 리스트 5개 이상일때만 더보기 노출
                    if (data.productInfoListCount > 4 || data.productInfoList.length > 4) {
                        self.$el.find(".recom-product .btn-area").show();
                    } else {
                        self.$el.find(".recom-product .btn-area").hide();
                    }
                    self.$el.find(".no-data").hide();
                    lists = vcui.template(MKTF30022_tmpl_product, data);
                    self.$addTmplProduct.html(lists);
                }
                //업셀링 제품추천 > TABS
                if (data.upsellingList && data.upsellingList.length > 0) {
                    self.dataUpsellingList = data.upsellingList;
                    lists = vcui.template(MKTF30022_tmpl_product_up_tab, data);
                    self.$addTmplProductUpTabs.html(lists);
                    setTimeout(function () {
                        var tabIns = self.$uiTab.vcTab("instance") || self.$uiTab.vcTab().vcTab("instance");
                        tabIns.constructor.superClass.destroy.apply(tabIns);
                        setTimeout(function () {
                            self.$uiTab.vcTab();
                        }, 100);
                    }, 300);
                } else {
                    self.$el.find(".re-tit.max-w").css("padding-bottom", "0").html("");
                    self.$el.find(".gray-full-box").hide();
                }
                //더 많은 제품 둘러보기 param 적용
                for (var i = 0; i < data.curationItem.filters.length; i++) {
                    var amp = "&";
                    if (i === data.curationItem.filters.length - 1) {
                        amp = "";
                    }
                    self.filterParam += data.curationItem.filters[i].filterId + "=" + data.curationItem.filters[i].filterValueId + amp;
                }
                self.bindEvents();
                $(window).scrollTop(0);
                if(self.$tbd.vcLazyLoaderSwitch){
                    self.$tbd.vcLazyLoaderSwitch()//.vcLazyLoaderSwitch('instance').reload(self.$tbd);
                    self.$tbd.css('visibility','visible');
                    $(window).scrollTop(0);
                }else{
                    vcui.require([
                        'ui/lazyLoaderSwitch',
                    ], function () {
                        self.$tbd.vcLazyLoaderSwitch()//.vcLazyLoaderSwitch('instance').reload(self.$tbd);
                        self.$tbd.css('visibility','visible');
                        $(window).scrollTop(0);
                    }); 
                }
            });
        },
        getUrl: function () {
            var self = this;
            if (window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("wwwdev50") > -1) {
                self.isPubl = true;
                return self.publUrl;
            } else {
                self.isPubl = false;
                return self.url;
            }
        },
        bindEvents: function () {
            var self = this;
            $("[data-href]").on("click", function (e) {
                window.location.href = $(this).attr("data-href");
            });
            //더 많은 제품 둘러보기
            
            $(".recom-product .btn.border.size-m").on("click", function (e) {
                window.location.href = self.getUrl().lifeFindUrl + "?" + self.filterParam;
            });
            //업셀링 제품추천 > TABS
            self.$addTmplProductUpTabs.find("a").on("click", function (e) {
                e.preventDefault();
                $(window).scrollTop(self.$el.find(".gray-full-box").offset().top - $(".gram-nav-wrap").height());
                setTimeout(function () {
                    self.moveTabContents($(e.target).attr("data-id"));
                }, 20);
            });
            self.$addTmplProductUpTabs.find("a").eq(0).trigger("click");

            //플로팅 버튼
            self.floatingBtn.on("click", function (e) {
                e.preventDefault();
                self.lifeY = $(".recommend-detail-wrap").offset().top + $(".recommend-detail-wrap").height() + 75 - 50;
                var sTop = self.lifeY + 2;
                if ($(window).scrollTop() > self.lifeY) {
                    //sTop = 0;
                    window.location.href = self.getUrl().lifeReUrl;
                    return;
                }
                $(window).scrollTop(sTop);
                setTimeout(function(){
                    self.lifeY = $(".recommend-detail-wrap").offset().top + $(".recommend-detail-wrap").height() + 75 - 50;
                    sTop = self.lifeY + 2;
                    $(window).scrollTop(sTop);
                    setTimeout(function(){
                        self.lifeY = $(".recommend-detail-wrap").offset().top + $(".recommend-detail-wrap").height() + 75 - 50;
                        sTop = self.lifeY + 2;
                        $(window).scrollTop(sTop);
                    })
                })
            });
         
            $('.recommend-disc-btn').on('click',function(){
                var $this = $(this).parents('.recommend-disc-wrap');
                if($this.hasClass('expanded')){
                    $this.removeClass('expanded');
                    $(this).attr('aria-expanded',false);
                }else{
                    $this.addClass('expanded');
                    $(this).attr('aria-expanded',true);
                }
            });
            
            
            $(window).on("scroll", function () {
                self.lifeY = $(".recommend-detail-wrap").offset().top + $(".recommend-detail-wrap").height() + 75 - 50; // 라이프스타일 다시 선택하기 버튼 - 탑헤더
                var top = $(this).scrollTop();
                if (top > self.lifeY) {
                    self.floatingBtn.show();
                    self.floatingBtn.text("라이프스타일 다시 선택하기");
                    return;
                } else {
                    self.floatingBtn.show();
                    self.floatingBtn.text("추천제품 바로보기");
                }
                var lifeBtnTop = $(".cont-wrap .btn-area").eq(0).offset().top;
                if (lifeBtnTop - $(window).height() < top || top == 0) {
                    self.floatingBtn.hide();
                }
            }).on("load",function(){
                $(window).trigger("scroll");
                self.floatingBtn.css('visibility','visible');
            }).trigger("scroll");
        },
        requestData: function (_json, _post, _func) {
            var self = this;
            var ajaxUrl = _json;
            var postData = _post;
            lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function (result) {
                _func(result);
            });
        },
        getAllUrlParams: function () {
            var url = window.location.href;
            var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
            var obj = {};
            if (queryString) {
                queryString = queryString.split("#")[0];
                var arr = queryString.split("&");
                for (var i = 0; i < arr.length; i++) {
                    var a = arr[i].split("=");
                    var paramName = a[0];
                    var paramValue = typeof a[1] === "undefined" ? true : a[1];
                    //paramName = paramName.toLowerCase();
                    if (typeof paramValue === "string") paramValue = paramValue.toLowerCase();
                    if (paramName.match(/\[(\d+)?\]$/)) {
                        var key = paramName.replace(/\[(\d+)?\]/, "");
                        if (!obj[key]) obj[key] = [];
                        if (paramName.match(/\[\d+\]$/)) {
                            var index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            obj[key].push(paramValue);
                        }
                    } else {
                        if (!obj[paramName]) {
                            obj[paramName] = paramValue;
                        } else if (obj[paramName] && typeof obj[paramName] === "string") {
                            obj[paramName] = [obj[paramName]];
                            obj[paramName].push(paramValue);
                        } else {
                            obj[paramName].push(paramValue);
                        }
                    }
                }
            }
            return obj;
        },
        //업셀링 제품추천 > TABS CONTENTS
        moveTabContents: function (_upsellingId) {
            var self = this;
            var idx = self.$uiTab.vcTab("instance").selectedIndex || self.$uiTab.vcTab("instance").selectedIndex;
            //배너
            self.dataUpsellingList[idx];
            self.$bnrH.text(self.dataUpsellingList[idx].upsellingTitle);
            self.$bnrP.text(self.dataUpsellingList[idx].upsellingDesc);
            //업셀링 제품추천 리스트 연동
            self.requestData(
                self.getUrl().jsonLifeStyleUpResult,
                { curationId: self.curationId, upsellingId: _upsellingId },
                function (result) {
                    var data = result.data[0];
                    self.$addTmplProductUp = self.$el.find(".gray-full-box .box-list .box-list-inner");
                    if (self.isPubl) {
                        var tranData = { productInfoList: [] };
                        if (_upsellingId == 1) {
                            tranData.productInfoList.push(data.productInfoList[0]);
                        } else if (_upsellingId == 2) {
                            tranData.productInfoList.push(data.productInfoList[1]);
                            tranData.productInfoList.push(data.productInfoList[2]);
                        } else if (_upsellingId == 3) {
                            tranData.productInfoList.push(data.productInfoList[3]);
                        } else if (_upsellingId == 4) {
                            tranData.productInfoList.push(data.productInfoList[4]);
                        } else if (_upsellingId == 5) {
                            tranData.productInfoList.push(data.productInfoList[5]);
                        }
                        lists = vcui.template(MKTF30022_tmpl_product_up_list, tranData);
                        self.$addTmplProductUp.html(lists);
                    } else {
                        lists = vcui.template(MKTF30022_tmpl_product_up_list, data);
                        self.$addTmplProductUp.html(lists);
                    }
                }
            );
        },
    };
    $(document).ready(function () {
        $('.ui_sticky').removeClass('ui_sticky').addClass('ui_sticky_recomm');
        if (!document.querySelector(".MKTF30022")) return false;
        $(".MKTF30022").buildCommonUI();
        MKTF30022.init();
    });
})();
